import { useEffect, useState } from "react";
import { getQueryData } from '../../../common';
import { searchComplexesV3, searchFrontYards, searchLivingAreas } from '../../../repository/RealEstateRepository';
import { ComplexList } from '../organism';
import { DefaultPage } from "./DefaultPage";

const ComplexListPage = (props) => {
  const [queryParams, setQueryParams] = useState(null);
  const [frontYards, setFrontYards] = useState([]);
  const [livingAreas, setLivingAreas] = useState([]);
  const [complexes, setComplexes] = useState([]);
  const [onLoad, setOnLoad] = useState(false);

  const getLinks = () => [
    {
      title: "Home",
      to: "/realestate"
    },
    {
      title: "Complex",
    }
  ];

  useEffect(() => {
    const queryParams = getQueryData(props.location.search);
    setQueryParams(queryParams);
    setTimeout(() => setOnLoad(true));
    // render FrontYard
    searchFrontYards({ ...queryParams }, (res1) => setFrontYards(res1.content));
    // render LivingArea
    if (queryParams.frontYardId) {
      searchLivingAreas({ ...queryParams }, (res2) => setLivingAreas(res2.content));
      searchComplexesV3({ ...queryParams }, (res3) => setComplexes(res3.content));
    } else {
      setLivingAreas([]);
      setComplexes([]);
    }
  }, [props.location]);

  return (<>
    <DefaultPage pathname={props.location.pathname} links={getLinks()}>
      {onLoad && (<>
        <ComplexList
          history={props.history}
          queryParams={queryParams}
          frontYards={frontYards}
          livingAreas={livingAreas}
          complexes={complexes} />
      </>)}
    </DefaultPage>
  </>);
};

export { ComplexListPage };
